// extracted by mini-css-extract-plugin
export default {"hitPointsBox":"styles_hitPointsBox__iqcr7","content":"styles_content__nPt0e","label":"styles_label__Ivf2i"};